import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import StockBatchService from "../../Controller/PartBatchController";
import HelpSite from "../../../Common/HelpLink";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import PartService from "../../Controller/PartController"
import { handleChange } from "../../Controller/UpdateFinancialController";
import Draggable from 'react-draggable';
import StockBatchStatusModal from "./StockBatchStatus";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
function StockBatchPage({ StockID, onClose }) {

    const navigate = useNavigate();
    const PartID = StockID;
    const [formData, setFormData] = useState({

    });
    const [StockBatchList, setStockBatches] = useState([]);
    const [StockBatchLocationList, setStockBatchLocation] = useState([]);
    const [StockLocationList, setStockLocation] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [batchID, setBatchID] = useState("0");
    const activeDateFormat = useDateFormat();
    const [isMinimized, setIsMinimized] = useState(false);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);

    const [sortConfig, setSortConfig] = useState({ key: 'PK_Batch_ID', direction: 'desc' });
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };

    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());


    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const fetchStockBatches = async (StockLocationID, page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();

            const data = await StockBatchService.GetAllNewStockBatches(redirectCallback, PartID, StockLocationID, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
            setStockBatches(data);

            const leadCount = await StockBatchService.GetStockBatchesCount(redirectCallback, PartID, StockLocationID, searchQuery);
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
        } catch (error) {
            console.error('Error fetching stock discounts:', error);
        }
    };
    const fetchStockBatchLocations = async () => {
        try {
            const data = await StockBatchService.GetAllStockBatchLocations(redirectCallback, PartID);
            setStockBatchLocation(data);
        } catch (error) {
            console.error('Error fetching stock discounts:', error);
        }
    };
    const fetchStockLocations = async (currentPage, pageSize) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const PartID = StockID;
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            setStockLocation(listOfLocations);
            if (listOfLocations.length > 0) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    PK_StockLocation_ID: listOfLocations[0].PK_StockLocation_ID, // Assuming IssuePriorityID is the field name
                }));

                await fetchStockBatches(listOfLocations[0].PK_StockLocation_ID, currentPage, pageSize);
            }
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    useEffect(() => {
        if (PartID > 0) {
            //  fetchStockBatches();
            //  fetchStockBatchLocations();
            fetchStockLocations(currentPage, pageSize);
        }
    }, [PartID, currentPage, pageSize]);
    const handleFieldChange = async (event) => {
        handleChange(event, formData, setFormData);
        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };
        if (name === 'PK_StockLocation_ID') {
            setStockBatches([]);
            await fetchStockBatches(value, "0", pageSize);
        }
        setFormData(updatedFormData);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setBatchID("0");
    };
    const handleBatchClick = async (event, PK_Batch_ID) => {

        event.stopPropagation();

        setIsModalOpen(true);
        setBatchID(PK_Batch_ID);
    };
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setStockBatches([]); // Clear previous data
        const query = searchQuery.toLowerCase(); // Use current searchQuery state


        const data = await StockBatchService.GetAllNewStockBatches(redirectCallback, PartID, formData.PK_StockLocation_ID, currentPage.toString(), pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString());
        setStockBatches(data);

        const leadCount = await StockBatchService.GetStockBatchesCount(redirectCallback, PartID, formData.PK_StockLocation_ID, searchQuery);
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const handlePageChange = (page) => {
        setStockBatches([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>


            <div className="modal fade stockBatchSerchModal show d-block" id="stockBatchSerchModal" tabIndex="-1" aria-labelledby="stockBatchSerchModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">

                        <div className="modal-content" style={{ height: '100%', width: '100%' }}>
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Batch History</h5>


                                <span>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                        <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                    </button>

                                </span>


                            </div>
                            {!isMinimized && (
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <label htmlFor="vc_SerialPrefix" className="col-sm-2 col-form-label">Select Location</label>
                                        <div className="col-sm-4">
                                            <select name="PK_StockLocation_ID" className='form-control' value={formData.PK_StockLocation_ID} onChange={handleFieldChange}>
                                                <option value="0">Select Location</option>
                                                {StockLocationList.map((location) => (
                                                    <option key={location.PK_StockLocation_ID} value={location.PK_StockLocation_ID}>
                                                        {location.vc_Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-sm-6" style={{ textAlign: "right" }}>
                                            <HelpSite FormName="Batches" Module="5" />
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>

                                        <div className="col-sm-12">
                                            <div className="table-responsive">
                                                <div className="row mb-3">
                                                    <div className="col-sm-1">
                                                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>
                                                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                                    <div className="col-sm-6"></div>
                                                    <div className="col-sm-1" style={{ "textAlign": "right" }}>Search</div>
                                                    <div className="col-sm-2 d-flex justify-content-end">
                                                        <input
                                                            type="text"
                                                            value={searchQuery}
                                                            onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                                                            className="form-control me-2" // Add margin to separate input and button

                                                        />
                                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <table className="table m-0 table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th className="no-wrap">Batch Number</th>
                                                            <th className="no-wrap">Supplier</th>
                                                            <th className="no-wrap">Quantity</th>
                                                            <th className="no-wrap">Date Created</th>
                                                            <th className="no-wrap">Expiry Date</th>
                                                            <th className="no-wrap">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {StockBatchList.map((stock, index) => {

                                                            const date = new Date(stock.dt_Created);
                                                            const formattedTime = date.toLocaleTimeString('en-US', {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: false, // Use 24-hour format
                                                            });
                                                            return (

                                                                <tr key={stock.PK_Batch_ID} onClick={(event) => handleBatchClick(event, stock.PK_Batch_ID)} style={{ cursor: 'pointer' }}>
                                                                    <td className="no-wrap">{stock.vc_BatchNumber}</td>
                                                                    <td className="no-wrap">{stock.vc_SupplierName}</td>
                                                                    <td className="no-wrap">{stock.dec_InitialQuantity}</td>

                                                                    <td className="no-wrap">
                                                                        {formatDateWithFns(stock.dt_Created, activeDateFormat)}   {formattedTime}

                                                                    </td>
                                                                    <td className="no-wrap">  {stock.dt_Expiry && formatDateWithFns(stock.dt_Expiry, activeDateFormat)} </td>
                                                                    <td className="no-wrap">{stock.Status}</td>

                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                                        <tr>
                                                            <td colSpan={8}>
                                                                <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                                    Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                                    {/* Last Page Button */}
                                                                    <button
                                                                        style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                                        className='btn btn-info'
                                                                        onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                                        disabled={currentPage === totalPages}
                                                                    >
                                                                        Last
                                                                    </button>

                                                                    {/* Next Page Button */}
                                                                    <button
                                                                        style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                                                                        className='btn btn-info'
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                        disabled={currentPage === totalPages}
                                                                    >
                                                                        Next
                                                                    </button>

                                                                    <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                                        Page {currentPage} of {totalPages}
                                                                    </span>

                                                                    {/* Previous Page Button */}
                                                                    <button
                                                                        style={{ padding: '5px 8px', float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                                        className='btn btn-info'
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                        disabled={currentPage === 1}
                                                                    >
                                                                        Prev
                                                                    </button>

                                                                    {/* First Page Button */}
                                                                    <button
                                                                        style={{ padding: '5px 8px', float: "right" }}
                                                                        className='btn btn-info'
                                                                        onClick={() => handlePageChange(1)} // Navigate to first page
                                                                        disabled={currentPage === 1}
                                                                    >
                                                                        First
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>


                                        {isModalOpen && (
                                            <StockBatchStatusModal BatchID={batchID} onClose={handleCloseModal} />
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
                                    </div>
                                </div>

                            )}
                        </div>

                    </Draggable>
                </div>
            </div>


        </div>
    );
}

export default StockBatchPage;
